import { StoreId } from "../../decorators/StoreIdDecorator";
import API from "../API";

// Export Batch Class config models
export { BatchClassMetadataData, BatchClassMetadata };

type BatchClassMetadataData = {
  id: string;
  batchClassId: string;
  name: string;
};

class BatchClassMetadata {
  id: string;
  @StoreId
  batchClassId: string;
  _name: string = "";
  set name(name: string) {
    let tmpName = name.trim();
    if (tmpName.length > 255) {
      tmpName = tmpName.substring(0, 254);
    }
    this._name = tmpName;
  }
  get name() {
    return this._name;
  }

  constructor(data: BatchClassMetadataData) {
    this.id = data.id;

    this.batchClassId = data.batchClassId;
    this.name = data.name;
  }

  toData(): BatchClassMetadataData {
    return {
      id: this.id,
      batchClassId: this.batchClassId,
      name: this.name,
    };
  }

  public static createTest(
    rest: Partial<BatchClassMetadataData> = {},
  ): BatchClassMetadata {
    const defaultBcc: BatchClassMetadataData = {
      id: "",
      batchClassId: "",
      name: "",
    };
    return new BatchClassMetadata({
      ...defaultBcc,
      ...rest,
    });
  }
  static syncRoles(batchClassId: string): Promise<Set<number>> {
    return API.get(`/v0/role`, {
      batchClassId: batchClassId,
    })
      .then((value) => value.json())
      .then((roles: number[]) =>
        roles.reduce(
          (prev: Set<number>, role: number, idx: number) => prev.add(role),
          new Set<number>(),
        ),
      )
      .catch(() => {
        return new Set<number>();
      });
  }
}
